module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Hiddentao Ventures","short_name":"hiddentao.vc","start_url":"/","background_color":"#000","theme_color":"#fff","display":"minimal-ui","legacy":false,"include_favicon":false,"theme_color_in_head":false,"icons":[],"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":null},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
